import { gql } from '@apollo/client';

export const GET_FAQ_CATEGORIES = gql`
  query FaqCategories {
    faqCategories {
      slug
      name
      questions {
        id
        question
        answer
      }
    }
  }
`;
